/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Represents LPLookKeyType Attributes
 * <\/code><\/pre>
 **/
export var LPLookUpKeyType;
(function (LPLookUpKeyType) {
    LPLookUpKeyType["TFS_SCAC_ID"] = "TFS_SCAC_ID";
})(LPLookUpKeyType || (LPLookUpKeyType = {}));
